import { Box, type BoxProps, type Theme } from "@mui/material";
import { mergeSxProps } from "@src/appV2/lib";

export interface FloatingNavigationItemWrapperProps extends BoxProps {}

/**
 * Floating navigation item wrapper that appears in the bottom of the page
 * with navy background matching the sidebar
 */
export function FloatingNavigationItemWrapper(props: FloatingNavigationItemWrapperProps) {
  const { sx, ...restProps } = props;

  return (
    <Box
      sx={mergeSxProps(
        (theme: Theme) => ({
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-start",
          alignItems: "center",
          bottom: `calc(${theme.size?.floatingNavigation.margin} + env(safe-area-inset-bottom, 0px))`,
          position: "fixed",
          gap: 3,
          padding: 2,
          color: theme.palette.navbar?.itemContentSelected,
          height: theme.size?.floatingNavigation.height,
          userSelect: "none",
          borderRadius: theme.borderRadius?.xxxLarge,
          cursor: "pointer",
          zIndex: theme.zIndex.fab,

          // Navy background matching sidebar
          background: theme.palette.navbar?.gradient,
          boxShadow: "0 4px 16px rgba(0, 0, 0, 0.25), 0 1px 4px rgba(0, 0, 0, 0.15)",

          transition: theme.transitions.create(["box-shadow", "transform"], {
            duration: theme.transitions.duration.short,
          }),

          "&:hover": {
            boxShadow: "0 6px 16px rgba(0, 0, 0, 0.2)",
            transform: "translateY(-2px)",
          },

          "&:active": {
            transform: "translateY(0px)",
            boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
          },
        }),
        sx
      )}
      {...restProps}
    />
  );
}
